<div id="admin-dialog">
  <div mat-dialog-title>
    <!-- <div *ngIf="data.header_msg == 'Success!'"><em  class="bi bi-check-circle text-success"></em></div> -->
    <p style="font-weight: 500;font-size: 20px;">{{ data.header_msg }}</p>
  </div>
  <div mat-dialog-content>
    <p>{{ data.header_msg_description }}</p>
  </div>
  <div mat-dialog-actions align="end">
    <button
      style="background-color:#E61A27;color:white;"
      mat-flat-button
      class="close-button"
      (click)="closeDialog()"
    >
      Close
    </button>
  </div>
</div>
